import { ReactNode } from 'react'

type DetailsValueProps = {
  label: string
  value?: ReactNode
  emptyValue?: ReactNode
}

const DetailsValue = ({ label, value, emptyValue }: DetailsValueProps) => {
  if (!value && !emptyValue) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      <p className="typography-body text-neutral-500 font-semibold">{label}</p>
      <p className="typography-body-l font-medium text-neutral-700 whitespace-pre-wrap">{value || emptyValue}</p>
    </div>
  )
}

export default DetailsValue
